export default "__VITE_ASSET__SVJNjQr6__"